import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { VirtualizedTableProps } from 'services/virtualizedTable/types';
import { makeSelectEntityNames } from './selectors';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    entityNames?: ReturnType<ReturnType<typeof makeSelectEntityNames>>;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableEntityListComponent = (
    props: Props
): React.ReactElement | null => {
    const { entityNames } = props;

    return <span title={entityNames}>{entityNames}</span>;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityNames: makeSelectEntityNames()
});

export default connect(mapStateToProps)(VirtualizedTableEntityListComponent);
